import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';
import {isFirstLoad} from 'nutshell-core/utils/graphql-loading';

import type {
    GetTaskDisplayCount as GetTaskDisplayCountQuery,
    GetTaskDisplayCountVariables,
} from 'nutshell-graphql-types';

import GET_TASK_DISPLAY_COUNT from '../queries/get-task-display-count.graphql';

export const useGetTaskDisplayCount = (
    leadId: string
): {
    displayCount: number | null | undefined;
    isLoading: boolean;
    isFirstLoad: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} => {
    const {loading, data, error, refetch, networkStatus} = useQuery<
        GetTaskDisplayCountQuery,
        GetTaskDisplayCountVariables
    >(GET_TASK_DISPLAY_COUNT, {
        variables: {
            leadId,
        },
        fetchPolicy: 'cache-and-network',
    });

    const displayCount =
        data &&
        data.lead &&
        data.lead.tasks &&
        data.lead.tasks.filter((task) => !task.isCompleted).length;

    return {
        displayCount,
        isLoading: loading,
        isFirstLoad: isFirstLoad(networkStatus),
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
};
